import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import ProtectedRoute from "../components/admin/ProtectedRoute";
import AdminLayout from "../components/admin/AdminLayout";

const HomePage = lazy(() => import("../pages/home/page"));
const RegistrationPage = lazy(() => import("../pages/registration/page"));
const GalleryPage = lazy(() => import("../pages/gallery/page"));
const ThankYouPage = lazy(() => import("../pages/thank-you/page"));
const NotFound = lazy(() => import("../pages/NotFound"));
const AdminLoginPage = lazy(() => import("../pages/admin/LoginPage"));
const AdminApplicantsPage = lazy(() => import("../pages/admin/ApplicantsPage"));
const EventInfoPage = lazy(() => import("../pages/event-info/page"));
const TravelInfoPage = lazy(() => import("../pages/travel-info/page"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/registration",
    element: <RegistrationPage />,
  },
  {
    path: "/event-info",
    element: <EventInfoPage />,
  },
  {
    path: "/travel-info",
    element: <TravelInfoPage />,
  },
  {
    path: "/gallery",
    element: <GalleryPage />,
  },
  {
    path: "/thank-you",
    element: <ThankYouPage />,
  },
  {
    path: "/admin/login",
    element: <AdminLoginPage />,
  },
  {
    path: "/admin",
    element: (
      <ProtectedRoute>
        <AdminLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <AdminApplicantsPage />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
